export default "__VITE_ASSET__BEbvfo90__"